import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css";
import { ToastContainer, toast, Zoom, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../../context/auth";
import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { ThreeDots } from "react-loader-spinner";
import { useThemeContext } from "../../context/ThemeContext";
const BannerDetail = () => {
  const navigate = useNavigate();
  const { token, user } = useAuth();
  const { id } = useParams();
  const { currentMode, setCurrentMode } = useThemeContext();
  const [acceptedBannerId, setAcceptedBannerId] = useState(null);
  const [rejectBannerId, setRejectBannerId] = useState(null);
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  };

  const bannerDetailData = useQuery(
    ["bannerDetailDataApi", id],
    async () =>
      await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}banner/company/find/${id}`,
        {
          headers,
        }
      ),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token,
      onSuccess: (res) => {},
    }
  );

  const handleAccept = (id) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="bg-[#edf2f6]  p-4 py-4 flex items-center flex-col space-y-2">
            <h1 className="text-dark-color font-bold">
              Are You Sure, You want to accept the request this banner ?
            </h1>

            <div className="flex items-center justify-center space-x-5 w-full">
              <button
                onClick={onClose}
                className="bg-blue-bg rounded-sm text-center
                     px-5 p-2 font-medium text-sm text-white capitalize"
              >
                No
              </button>
              <button
                onClick={() => {
                  setAcceptedBannerId(id);
                  onClose();
                }}
                className="bg-red-500 rounded-sm text-center
              px-5 p-2 font-medium text-sm text-white capitalize"
              >
                Yes
              </button>
            </div>
          </div>
        );
      },
    });
  };
  const acceptBannerAds = useQuery(
    ["acceptBannerAdsDataApi", acceptedBannerId],
    async () =>
      await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}banner/company/accept/${acceptedBannerId}`,
        {
          headers,
        }
      ),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token && !!acceptedBannerId,
      onSuccess: (res) => {
        toast.info(
          "banner ads request accepted successfully",
          { theme: "colored" },
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
          }
        );
        setTimeout(() => {
          setAcceptedBannerId(null);
          navigate("/banner");
        }, 2000);
      },
    }
  );

  const handleReject = (id) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="bg-[#edf2f6]  p-4 py-4 flex items-center flex-col space-y-2">
            <h1 className="text-dark-color font-bold">
              Are You Sure, You want to Reject the request this banner ?
            </h1>

            <div className="flex items-center justify-center space-x-5 w-full">
              <button
                onClick={onClose}
                className="bg-blue-bg rounded-sm text-center
                     px-5 p-2 font-medium text-sm text-white capitalize"
              >
                No
              </button>
              <button
                onClick={() => {
                  setRejectBannerId(id);
                  onClose();
                }}
                className="bg-red-500 rounded-sm text-center
              px-5 p-2 font-medium text-sm text-white capitalize"
              >
                Yes
              </button>
            </div>
          </div>
        );
      },
    });
  };
  const rejectBannerAds = useQuery(
    ["rejectBannerAdsDataApi", rejectBannerId],
    async () =>
      await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}banner/company/reject/${rejectBannerId}`,
        {
          headers,
        }
      ),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token && !!rejectBannerId,
      onSuccess: (res) => {
        toast.info(
          "banner ads request reject successfully",
          { theme: "colored" },
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
          }
        );
        setTimeout(() => {
          setRejectBannerId(null);
          navigate("/banner");
        }, 2000);
      },
    }
  );

  return (
    <div className="p-3 md:p-5">
      <div className="py-3">
        {bannerDetailData.isFetched ? (
          <div className="w-full flex flex-col bg-white dark:bg-secondary-dark-bg p-3 md:p-5">
            <img
              src={bannerDetailData?.data?.data?.data?.image}
              alt=""
              className="max-h-96 h-full rounded-md w-full object-cover"
            />
            <div className=" py-5 grid grid-cols-1 md:grid-cols-2 gap-5 w-full">
              <div>
                <div className="flex items-center space-x-2">
                  <h1 className="text-dark-color dark:text-white font-bold text-2xl">
                    Owner:
                  </h1>
                  <h2 className="text-dark-color dark:text-white font-bold text-2xl">
                    {bannerDetailData?.data?.data?.data?.owner?.name}
                  </h2>
                </div>
              </div>
              <div>
                <div className="flex items-center space-x-2">
                  <h1 className="text-dark-color dark:text-white font-bold text-2xl">
                    Company:
                  </h1>
                  <h2 className="text-dark-color dark:text-white font-bold text-2xl">
                    {bannerDetailData?.data?.data?.company?.name}
                  </h2>
                </div>
              </div>
            </div>
            <div className=" py-5 flex items-center justify-center w-full space-x-3">
              <button
                onClick={() => {
                  handleAccept(id);
                }}
                className="bg-blue-bg rounded-sm text-center
                         px-5 p-2 font-medium text-white capitalize"
              >
                Accept
              </button>
              <button
                onClick={() => {
                  handleReject(id);
                }}
                className="bg-red-500 rounded-sm text-center
              px-5 p-2 font-medium text-white capitalize"
              >
                Reject
              </button>
            </div>
          </div>
        ) : (
          <div className="flex items-center justify-center">
            <ThreeDots
              height="80"
              width="80"
              radius="9"
              color="#216fed"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={true}
            />
          </div>
        )}
      </div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        transition={Slide}
      />
    </div>
  );
};

export default BannerDetail;
